








































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { mapMutations } from 'vuex';
import { GET_CUSTOMER_ID } from '@/modules/users/store/user.getters';
import { user } from '@/modules/shared/shared/store/namespaces';
import { TicketType } from '@/modules/shared/shared/domain/constants/constants';
import * as FORM_INTERFACE from './interfaces/accessTicket.interface';
import * as DB_INTERFACE from './interfaces/DB.interface';
import ticketsRepository from '../../../modules/tickets/shared/repositories/tickets.repository';
import StepGeneralInformation from './access/StepGeneralInformation.vue';
import StepPeopleInvolved from './access/StepPeopleInvolved.vue';
import StepAccessCars from './access/StepAccessCars.vue';
import StepTasks from './access/StepTasks.vue';
import StepHardware from './access/StepHardware.vue';
import StepAccessTicketConfirmation from './access/StepAccessTicketConfirmation.vue';
import { createFormToDB } from './utils/form-to-DB-mapping';
import { AccessFormValuesToForm } from './utils/DB-to-form-mapping';
import { EventBus } from '@/main';
import { EventBusMessages } from '@/modules/shared/shared/domain/constants/event-bus-messages';

@Component({
    components: {
        TicketAccessStepOne: StepGeneralInformation,
        TicketAccessStepTwo: StepPeopleInvolved,
        TicketAccessStepThree: StepAccessCars,
        TicketAccessStepFour: StepTasks,
        TicketAccessStepFive: StepHardware,
        TicketAccessStepSix: StepAccessTicketConfirmation,
    },
    methods: {
        ...mapMutations('layout', ['changeTitle']),
    },
})
export default class TicketsCreateAccess extends Vue {
    valid: boolean = false;
    highestStepReached: number = 1;
    currentStep: number = 1;
    requiresHardware: boolean = false;
    $refs!: {
        form: any;
        Step1: any;
        Step2: any;
        Step3: any;
        Step4: any;
        Step5: any;
        Step6: any;
    };
    formValues: FORM_INTERFACE.accessFormValuesInterface = {
        generalInformation: {
            dataCenters: Array(),
            reasons: Array(),
            motives: Array(),
        },
        tasks: {
            taskTypes: Array(),
        },
        hardwareTransfer: {
            accessEquipmentDepartureTypes: Array(),
            accessEquipmentDeparturePeriodTypes: Array(),
            movementTypes: Array(),
        },
        contactTypes: Array(),
    };
    accessTicket: FORM_INTERFACE.accessTicketInterface = {
        generalInformation: {} as FORM_INTERFACE.generalInformationInterface,
        involvedPeople: {} as FORM_INTERFACE.involvedPeopleInterface,
        accessCars: {} as FORM_INTERFACE.accessCarsInterface[],
        tasks: {} as FORM_INTERFACE.tasksInterface[],
        hardwareTransfer: Array(),
        contactTypeID: {} as FORM_INTERFACE.contactTypeIdInterface,
    };
    errorLoadingContent: boolean = false;

    nextStep() {
        if (this.currentStep < 6) {
            this.currentStep++;
            this.highestStepReached = this.currentStep;
            if (this.currentStep == 6) {
                this.requestData();
            }
            if (this.currentStep == 5 && !this.requiresHardware) {
                this.nextStep();
            }
        }
    }
    previousStep() {
        if (this.currentStep > 1) {
            this.currentStep--;
            if (this.currentStep == 5 && !this.requiresHardware) {
                this.previousStep();
            }
        }
    }

    requestData() {
        const stepNumbers = [1, 2, 3, 4];
        if (this.requiresHardware) {
            stepNumbers.push(5);
        } else {
            this.accessTicket.hardwareTransfer = Array();
        }
        stepNumbers.forEach(number => {
            Object.assign(this.accessTicket, this.$refs['Step' + number].sendData());
        });
        this.accessTicket.involvedPeople.applicant = Array();
        let applicant: FORM_INTERFACE.applicantInterface = {
            contactId: this.contact.id,
            firstName: this.contact.name,
            lastName: this.contact.lastName,
            telephoneNumber: this.contact.cellphone,
            idNumber: this.contact.ci,
            company: this.contact.customer.name,
        };
        this.accessTicket.involvedPeople.applicant.push(applicant);
    }

    @Watch('currentStep')
    debugFunction(value: any, oldValue: any) {
        if (this.currentStep == 6) {
            this.requestData();
        }
    }

    async mounted() {
        EventBus.$emit(EventBusMessages.SHOW_LOADER);
        //@ts-ignore
        this.changeTitle({ title: 'Ticket de Acceso', route: ['TICKETS'] });
        const customerID: number = this.GET_CUSTOMER_ID;
        try {
            const response = await ticketsRepository.getDataCreateTicket(
                customerID,
                TicketType.ACCESS,
            );
            const dataCreateTicket = response.data.values;

            this.formValues = AccessFormValuesToForm(dataCreateTicket);
            this.formValues.contactTypes.forEach(contactType => {
                switch (contactType.text) {
                    case 'Responsable':
                        this.accessTicket.contactTypeID.responsiblePerson = contactType.value;
                        break;
                    case 'Autorizado':
                        this.accessTicket.contactTypeID.authorizedPeople = contactType.value;
                        break;
                    case 'Involucrado':
                        this.accessTicket.contactTypeID.additionalPeople = contactType.value;
                        break;
                    case 'Solicitante':
                        this.accessTicket.contactTypeID.applicant = contactType.value;
                        break;
                    default:
                        break;
                }
            });
        } catch (error) {
            // console.warn(error)
        }

        EventBus.$emit(EventBusMessages.HIDE_LOADER);
    }

    async sendAccessTicket() {
        const stepNumbers = [1, 2, 3, 4];
        if (this.requiresHardware) {
            stepNumbers.push(5);
        }

        let incompleteSteps = Array();
        stepNumbers.forEach(number => {
            if (number == 1) {
                if (this.$refs['Step1'].checkTime() == false) {
                    this.$refs['Step1'].setInvalidTimeError();
                    incompleteSteps.push(number);
                }
            }
            if (this.$refs['Step' + number].$refs.form.validate() == false) {
                incompleteSteps.push(number);
            }
        });

        if (incompleteSteps.length > 0) {
            this.currentStep = Math.min(...incompleteSteps);
        } else {
            if (this.currentStep != 6) {
                this.currentStep = 6;
            } else {
                let headquartersName: string = '';
                this.formValues.generalInformation.dataCenters.forEach(dataCenter => {
                    if (dataCenter.value == this.accessTicket.generalInformation.headquarters) {
                        headquartersName = dataCenter.text;
                    }
                });
                const accessTicket: DB_INTERFACE.accessTicketInterface = createFormToDB(
                    this.accessTicket,
                    this.contact,
                    this.formValues.generalInformation.reasons,
                    headquartersName,
                );
                try {
                    EventBus.$emit(EventBusMessages.SHOW_LOADER);
                    const response = await ticketsRepository.createTicket(accessTicket);
                    EventBus.$emit(EventBusMessages.HIDE_LOADER);
                    this.$router.push({
                        name: 'tickets',
                        params: { ticket: 'success', id: response.data.id },
                    });
                } catch (ex) {
                    EventBus.$emit(EventBusMessages.HIDE_LOADER);
                    this.$router.push({ name: 'tickets', params: { ticket: 'error' } });
                }
            }
        }
    }

    enableHardwareStep(motives: number[]) {
        //! FIX: Mover a un archivo de constantes
        let hardwareRelatedMotives: number[] = [4, 5, 10, 12, 13, 14, 18, 19];

        if (motives.some(motive => hardwareRelatedMotives.includes(motive))) {
            this.requiresHardware = true;
        } else {
            this.requiresHardware = false;
        }
    }

    beforeDestroy() {
        localStorage.removeItem('accessTicket');
    }
    @user.Getter(GET_CUSTOMER_ID) GET_CUSTOMER_ID;
    @user.State('contact') contact;
}
